import { useState } from "react";
import { usePreconfiguredPeriods } from "./general/usePreconfiguredPeriods";
import { endOfDay, startOfDay } from "date-fns";
import { pick } from "lodash";
export function useAnalyticDates() {
    const [periodIndex, setPeriodIndex] = useState(0);
    const [customDates, setCustomDates] = useState([]);
    const preconfiguredPeriods = usePreconfiguredPeriods();
    const dates = periodIndex === -1 ? {
        start: startOfDay(customDates[0]),
        end: endOfDay(customDates[1])
    } : pick(preconfiguredPeriods[periodIndex], ['start', 'end']);
    return {
        dates,
        preconfiguredPeriods,
        currentPeriod: periodIndex,
        setPeriod: setPeriodIndex,
        setCustomPeriod: (dates) => {
            setCustomDates(dates);
            setPeriodIndex(-1);
        }
    };
}
